import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// Función para aplanar objetos anidados manteniendo la estructura de carpetas
function flattenTranslations(files) {
  const translations = {}

  files.keys().forEach(key => {
    // Extraer el path completo sin ./ al inicio y .js al final
    // Ejemplo: ./reusable/common.js -> reusable/common
    const path = key.replace(/^\.\//, '').replace(/\.js$/, '')
    const parts = path.split('/')

    // Si está en una subcarpeta, crear estructura anidada
    if (parts.length > 1) {
      const folder = parts[0]
      const fileName = parts[parts.length - 1]

      if (!translations[folder]) {
        translations[folder] = {}
      }
      translations[folder][fileName] = files(key).default
    } else {
      // Si está en la raíz, agregarlo directamente
      translations[parts[0]] = files(key).default
    }
  })

  return translations
}

// Auto-importar todos los archivos de traducciones (incluyendo subcarpetas)
const es = {}
const en = {}

// Importar automáticamente todos los archivos .js de /es/ y sus subcarpetas (recursive: true)
const esFiles = require.context('./es', true, /\.js$/)
Object.assign(es, flattenTranslations(esFiles))

// Importar automáticamente todos los archivos .js de /en/ y sus subcarpetas (recursive: true)
const enFiles = require.context('./en', true, /\.js$/)
Object.assign(en, flattenTranslations(enFiles))

const messages = { es, en }

// Obtener idioma: si hay sesión activa usar user_language, si no usar public_language
// SEC-3 fase 2: ya no hay token en localStorage — se usa el hint no sensible de sesión.
const isLoggedIn = !!localStorage.getItem('kl_session_hint')
const savedLanguage = isLoggedIn
  ? (localStorage.getItem('user_language') || 'es')
  : (localStorage.getItem('public_language') || 'es')

// Crear instancia de i18n
const i18n = new VueI18n({
  locale: savedLanguage, // idioma guardado del usuario
  fallbackLocale: 'es', // idioma de respaldo
  messages,
  missing: (locale, key) => {
    // Handler para claves faltantes cuando falla un texto u oración en la traducción
    // Retornar la última parte de la clave (ej: "home.aboutUsView.vision" -> "vision")
    const parts = key.split('.')
    return parts[parts.length - 1]

  }
})

export default i18n
